export const baseurl = 'https://digitalize.aiyd88.com'

export const appid = 'wxef7287bb04229749'

export const component_appid = ''

export const uniacid = '31'
